// Copyright (c) Docugami, Inc. All rights reserved.

const { v4: uuidv4 } = require('uuid');

interface RegisteredCallback {
    id: string
    callback: (value: any) => void;
}

export interface IEvent<T> {
    addListener(callback: (value: T) => void): () => void;
}

/**
 * Simple callback-based event delegate
 */
export class Event<T> implements IEvent<T> {
    private readonly _callbacks: RegisteredCallback[] = [];

    public addListener(callback: (value: any) => void): () => void {
        const id = uuidv4();

        this._callbacks.push({
            id: id,
            callback: callback
        });

        return () => this.remove(id);
    }

    public raise(value: T) {
        for (const cb of this._callbacks) {
            cb.callback(value);
        }
    }

    private remove(id: string) {
        const index = this._callbacks.findIndex(cb => cb.id === id);
        if (index !== -1) {
            this._callbacks.splice(index, 1);
        }
    }
}
